import { useCallback, useContext } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { getRoutePathById } from '@bingads-webui-react/with-site-map';

export const useBackToOverview = ({ siteMap }) => {
  const { scope } = useContext(ScopeContext);

  const backToOverviewPage = useCallback(() => {
    const route = getRoutePathById(siteMap, 'sdk-campaign-overview');
    scope.save(route);
  }, [scope, siteMap]);

  return {
    backToOverviewPage,
  };
};
